import React from "react"
import { Flex, Stack, Heading, CircularProgress } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"

export const LoadingView = () => {
  const { t } = useTranslation()
  return (
    <Flex
      minH="calc(100vh)"
      align={"center"}
      justify={"center"}
      bgGradient="linear(to-r, orange.400,green.200)"
      bgSize="cover"
      bgRepeat="no-repeat"
      pos="absolute"
      left="0"
      top="0"
      w="100%"
      zIndex={"popover"}
    >
      <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
        <Stack align={"center"}>
          <Heading fontSize={"2xl"}>{t("Loading...")}</Heading>
          <CircularProgress
            isIndeterminate
            value={30}
            color="orange.400"
            thickness="12px"
          />
        </Stack>
      </Stack>
    </Flex>
  )
}
export default LoadingView
